// components/Home.js
import React from 'react';
import Hero from './Hero';
import Locations from './Locations';
import { Link } from 'react-router-dom';

const Home = () => {
  const servicesPreview = [
    {
      title: "Commodity Trading",
      description: "Broad portfolio including bulk sugar, maize, wheat, small grains, and agro-products sourced from key global markets.",
      icon: "🌾"
    },
    {
      title: "Procurement & Supply",
      description: "End-to-end solutions from sourcing to final delivery, ensuring seamless supply chain management.",
      icon: "📦"
    },
    {
      title: "Supply Chain Credit Solutions",
      description: "Innovative trade finance solutions to optimize cash conversion cycles and improve liquidity.",
      icon: "💰"
    }
  ];

  const valuesPreview = [
    {
      number: "01",
      title: "Efficiency",
      description: "Streamlined, time-sensitive solutions that are cost-effective and aligned with client objectives.",
      icon: "⚡"
    },
    {
      number: "02", 
      title: "Partnership",
      description: "Building enduring, transparent, and mutually beneficial relationships with all stakeholders.",
      icon: "🤝"
    },
    {
      number: "03",
      title: "Convenience", 
      description: "Simplifying procurement and supply chain processes with accessible, reliable, and integrated services.",
      icon: "🎯"
    },
    {
      number: "04",
      title: "Innovation",
      description: "Continuously improving offerings and developing cutting-edge solutions for evolving client needs.",
      icon: "💡"
    }
  ];

  return (
    <div>
      <Hero />
      
      {/* About Preview */}
      <section id="about-preview" className="preview-section">
        <div className="container">
          <h2>About Oxycom</h2>
          <p className="about-description">
            Oxycom is a dynamic and established international trading and procurement 
            company dedicated to delivering comprehensive supply chain solutions for 
            enhanced efficiency and value, every step of the way from source to market.
          </p>
          <Link to="/about" className="cta-button">Learn More About Us</Link>
        </div>
      </section>

      {/* Services Preview */}
      <section id="services-preview" className="preview-section">
        <div className="container">
          <h2>Our Services</h2>
          <p>Comprehensive trading, procurement, and supply chain solutions tailored to meet your business needs across various commodities and markets.</p>
          <div className="services-grid">
            {servicesPreview.map((service, index) => (
              <div key={index} className="service-preview">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
          <Link to="/services" className="cta-button">View All Services</Link>
        </div>
      </section>

      {/* Values Preview */}
      <section id="values-preview" className="preview-section">
        <div className="container">
          <h2>Our Values</h2>
          <p>These core principles guide everything we do and define how we deliver value to our clients and partners.</p>
          <div className="values-grid">
            {valuesPreview.map((value, index) => (
              <div key={index} className="value-preview">
                <div className="value-header">
                  <span className="value-number">{value.number}</span>
                  <div className="value-icon">{value.icon}</div>
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
          <Link to="/values" className="cta-button">Discover Our Values</Link>
        </div>
      </section>
      <Locations />

      {/* Contact CTA */}
      <section id="contact-cta" className="preview-section cta-section">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Contact us today to discuss how we can meet your commodity trading and supply chain needs.</p>
          <Link to="/contact" className="cta-button primary">Contact Us</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;